import { useState, useEffect } from 'react';
import { SavChatRepository } from '@/services/firebase/sav-chat-repository';

/**
 * Hook pour récupérer le nombre de messages non lus pour une commande donnée
 * Retourne le nombre de messages non lus par le client (envoyés par l'admin)
 */
export const useOrderUnreadMessages = (orderId: string | null, customerId: string | null) => {
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [hasActiveChat, setHasActiveChat] = useState<boolean>(false);

  useEffect(() => {
    if (!orderId || !customerId) {
      setUnreadCount(0);
      setHasActiveChat(false);
      return;
    }

    const loadChatInfo = async () => {
      try {
        const chat = await SavChatRepository.getChatByOrderId(orderId, customerId);
        if (chat) {
          setHasActiveChat(true);
          setUnreadCount(chat.unreadByCustomer || 0);
        } else {
          setHasActiveChat(false);
          setUnreadCount(0);
        }
      } catch (error) {
        console.error('Error loading chat info:', error);
        setHasActiveChat(false);
        setUnreadCount(0);
      }
    };

    loadChatInfo();

    // Écouter les changements en temps réel
    const unsubscribe = SavChatRepository.subscribeToOrderChat(
      orderId,
      customerId,
      (chat) => {
        if (chat) {
          setHasActiveChat(true);
          setUnreadCount(chat.unreadByCustomer || 0);
        } else {
          setHasActiveChat(false);
          setUnreadCount(0);
        }
      },
      (error) => {
        console.error('Error subscribing to chat:', error);
      }
    );

    return () => unsubscribe();
  }, [orderId, customerId]);

  return {
    unreadCount,
    hasActiveChat,
  };
};

